module.exports = __webpack_public_path__ + "img/hr-puberty-decal-20.d4ee14bc.png";